import React, { useState, useRef, useEffect } from 'react';
import { Alert, Col, FormGroup, Row, CustomInput, Collapse, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select'
import ReactGA from 'react-ga'

import { questionnaireStoreOptionsActions } from '../../../../core/questionnaire-storeOptions/actions';
import { questionnaireItemsActions } from '../../../../core/questionnaire-items/actions';
import { trackingActions } from '../../../../core/tracking';
import { Optioncustom } from './OptionCustom';
import { ModalLockedAssessment } from '../../common/locks';

export const Question = ({ question, index, questionnaie_id, questionnaire, locked }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user );
    const [optionSelected, setOptionSelected] = useState([]);
    const [showQuestion, setShowQuestion] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [allValid, setAllValid] = useState(true);
    const [openModalLock, setOpenModalLock] = useState(false);

    const selectRef = useRef();

    const eventGA = () => {
        ReactGA.event({
            category: 'Questionnaires',
            action: `Review answers ${questionnaire?.name} completed`
        })
    }

    const ourTracking = () => {
        dispatch(trackingActions.saveTrackingEvent({ category: 'Questionnaires', action: `Review answers ${questionnaire?.code || questionnaire?.name} completed` }))
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted) { isSelected() }
        return () => {
            isMounted = false;
        }
    }, [])

    useEffect(() => {
        disabledbtn();
        areAllValid() ? setAllValid(true) : setAllValid(allValid);
    }, [optionSelected])

    const toggleQuestion = () => {
        setShowQuestion(!showQuestion);
    }

    const buildOptions = (optionId, checked) => {
        if (checked) {
            setOptionSelected([
                ...optionSelected,
                {
                    id: optionId,
                    checked,
                }
            ])
        } else {
            setOptionSelected(
                optionSelected.filter(option => option.id !== optionId)
            )
            document.getElementById(optionId).removeAttribute('checked')
        }
    }

    const isSelected = () => {
        if (question.type === 'sel' && question.selected.length > 0) {
            setOptionSelected([{ id: question.selected[0].option_id, custom_value: question.selected[0].custom_value ? question.selected[0].custom_value : '' }])
            question.options.forEach(option => {
                if (option.id === question.selected[0].option_id) {
                    option.custom_value = question.selected[0].custom_value ? question.selected[0].custom_value : ''
                } else {
                    option.custom_value = ''
                }
            })
        }
        else {
            question.options.forEach(option => {
                option.custom_value = ''
                question.selected.forEach(selected => {
                    if (option.id.toString() === selected.option_id.toString()) {
                        document.getElementById(option.id).setAttribute('checked', true)
                        let optionsSelected = optionSelected;
                        optionsSelected.push({
                            id: option.id.toString(),
                            checked: true,
                            custom_value: selected.custom_value ? selected.custom_value : '',
                        });
                        option.custom_value = selected.custom_value ? selected.custom_value : '';
                    }
                });
            })
        }
    }

    const saveAnswer = () => {
        if (areAllValid()) {
            dispatch(questionnaireStoreOptionsActions.saveQuestionnaireStoreOptions({ questionnaireId: questionnaie_id, questionId: question.id, options: optionSelected }));
            dispatch(questionnaireItemsActions.loadQuestionnaireItems(questionnaie_id));
            toggleQuestion();
        } else {
            setAllValid(false);
        }
    }

    const disabledbtn = () => {
        var valid = true;

        if (question && question.minimum && question.maximum) {
            if (optionSelected.length > question.maximum || optionSelected.length < question.minimum) {
                valid = false;
            } else {
                valid = true;
            }

            setDisabled(!valid);
            setShowAlert(!valid);
        }
    }

    const onChangeSelectedOption = (selectedOption) => {
        setAllValid(true);
        let value = '';
        question.selected.forEach(option => {
            if (option.option_id.toString() === selectedOption.value.toString()) {
                value = option.custom_value
            }
        });
        setOptionSelected([{ id: selectedOption.value, custom_value: value }])
    }

    const transformItemsIntoNameValue = (list) => {
        return list && list.map((element) => {
            return { value: element.id, label: element.title };
        });
    }

    let preSelected
    const getPreselected = () => {
        question.options.forEach(option => {
            if (option.id === question.selected[0].option_id) {
                preSelected = option.title
            }
        });
    }
    getPreselected()

    const optionCustomSelected = (opt) => {
        let value = false
        if (opt.custom_enable) {
            optionSelected.forEach(option => {
                if (option.id.toString() === opt.id.toString()) {
                    value = true
                }
            });
        }
        return value
    }

    const setValue = (target) => {
        optionSelected.forEach(option => {
            if (target.id.toString() === option.id.toString()) {
                option.custom_value = target.value;
            }
            if (areAllValid()) {
                setAllValid(true);
            }
        });
    }

    const validText = (optionId, mandatory) => {
        let valid = true;
        if (mandatory) {
            optionSelected.forEach(opt => {
                if (optionId.toString() === opt.id.toString()) {
                    if (!opt.custom_value || opt.custom_value === undefined || opt.custom_value == '') {
                        valid = false;
                    }
                }
            });
        }
        return valid
    }

    const areAllValid = () => {
        let boolean = true;
        question.options.forEach(option => {
            optionSelected.forEach(opt => {
                if (option.custom_mandatory && option.id.toString() === opt.id.toString()) {
                    if (!validText(option.id, option.custom_mandatory)) {
                        boolean = false
                    }
                }
            });
        });
        return boolean;
    }

    const newListOptions = transformItemsIntoNameValue(question && question.options && question.options);

    const handleUpdate = () => {
        if (locked) {
            setOpenModalLock(true);
            return;
        }

        saveAnswer();
        eventGA();
        ourTracking();
    }

    return (
        <>
            <div className="d-flex align-items-md-center cursor-pointer mb-3" onClick={() => toggleQuestion()} >
                <div className='mr-3'><div className="rounded-circle question-member bg-border-color text-center font-weight-bold">{index + 1}</div></div>
                <div className='flex-fill '>
                    <h2 className='mb-0 h6 h5-md'>{question.title}</h2>
                    <p className="mb-0">{question.subtitle}</p>
                </div>
                {showQuestion ? '' : ''}
                <div className="text-right">
                    <i>
                        <svg className={`${showQuestion ? 'fa-flip-vertical' : ''}`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill='currentColor'>
                            <g>
                                <path d="M10,14.6c-0.2,0-0.4-0.1-0.6-0.2L3.2,8.1c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0l5.7,5.7l5.7-5.7
                                    c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2l-6.2,6.2C10.4,14.5,10.2,14.6,10,14.6z"/>
                            </g>
                        </svg>
                    </i>
                </div>
            </div>

            <Collapse isOpen={showQuestion}>
                {question.help_text && <Alert color="primary" className="text-center font-weight-semibold border-0 py-2"><i>{question.help_text}</i></Alert>}
                {question.type !== 'sel' &&
                    <Row className="row-cols-1 row-cols-md-2 pb-5">
                        {question.options && question.options.map((option) =>
                            <Col key={question.id + "-" + option.id}>
                                {question.type === 'chk' &&

                                    <FormGroup className="border-bottom py-3 mb-0">
                                        <CustomInput type="checkbox" onClick={({ target }) => buildOptions(target.id, target.checked)} id={option.id}
                                            label={<>{option.title} {option.description && <i>{option.description}</i>}</>}
                                            disabled={locked}
                                            cssModule={{'custom-control-label': 'custom-control-label h5-md h6 font-weight-normal'}}
                                        />
                                        {optionCustomSelected(option) &&
                                            <Optioncustom
                                                option={option}
                                                setValue={setValue}
                                                validText={validText}
                                                allValid={allValid}
                                                locked={locked}
                                            />
                                        }
                                    </FormGroup>
                                }
                                {question.type === 'opt' &&
                                    <FormGroup className="border-bottom py-3 mb-0">
                                        <CustomInput type="radio" onClick={({ target }) => setOptionSelected([{ id: target.id }])} name={question.id} id={option.id}
                                            label={<>{option.title} {option.description && <i>{option.description}</i>}</>}
                                            disabled={locked}
                                            cssModule={{'custom-control-label': 'custom-control-label h5-md h6 font-weight-normal', 'custom-radio': 'custom-checkbox'}}
                                        />
                                        {optionCustomSelected(option) &&
                                            <Optioncustom
                                                option={option}
                                                setValue={setValue}
                                                validText={validText}
                                                allValid={allValid}
                                                locked={locked}
                                            />
                                        }
                                    </FormGroup>
                                }
                            </Col>
                        )}
                    </Row>
                }
                {question.type === "sel" &&
                    <div className="select-years-content ml-5 pl-1 pt-3 ml-md-0 pl-md-0 pt-md-0">
                        <Select options={newListOptions} ref={selectRef} defaultValue={{ label: preSelected, value: question.selected[0].option_id }}
                            onChange={onChangeSelectedOption} className="form-control-select select-years d-md-inline-block" classNamePrefix="form-control" placeholder={question && question.help_text} />
                        {question.options && question.options.map((option) =>
                            <div key={option.id}>
                                {
                                    optionCustomSelected(option) &&
                                    <Optioncustom
                                        option={option}
                                        setValue={setValue}
                                        validText={validText}
                                        allValid={allValid}
                                        type='select'
                                        locked={locked}
                                    />
                                }
                            </div>
                        )}
                    </div>
                }
                {(question && question.validation_message) &&
                    <>
                    {(disabled && showAlert) &&
                        <div className="text-danger text-center mb-3">
                            <p className="mb-0">{question && question.validation_message}</p>
                        </div>
                    }
                    </>
                }
                <div className="contenido-bottom-fixed-mb text-center pb-5">
                    <Button size="sm" color='outline-green-light' disabled={disabled || !allValid} className={`${locked ? 'disabled' : ''}`} onClick={handleUpdate}>Update</Button>
                </div>
            </Collapse>

            <ModalLockedAssessment
                isOpen={openModalLock}
                close={() => setOpenModalLock(false)}
                blockDays={user?.assessments_block_days}
            />
        </>
    )
}